



import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Form from "react-bootstrap/Form";
import { useScreenSize, ScreenSizeContext } from "../context/ScreenSizeContext";
import LogSign from "./logSign";
import CartMenu from "./cartsMenu";
import HelplineLanguage from "./helplineLanguage";
import LoadingSpinner from "../component/loadingSpinner";
import { fetchNavigationData } from "../redux/navigationSlice"; // Import the action



import {
  BsSearch,
  BsUiRadiosGrid,
  BsHouseDoor,
  BsNut,
  BsNewspaper,
  BsListNested,
  BsPatchQuestion,
  BsTelephonePlus,
  BsChevronDown,
  BsGear,
} from "react-icons/bs";

import "../css/nav.css";
import NavMenu from "./navMenu";

// Icon mapping for dynamic icons
const iconMapping = {
  BsHouseDoor: <BsHouseDoor />,
  BsNut: <BsNut />,
  BsNewspaper: <BsNewspaper />,
  BsListNested: <BsListNested />,
  BsPatchQuestion: <BsPatchQuestion />,
  BsTelephonePlus: <BsTelephonePlus />,
  BsGear: <BsGear />,
};

const Navigation = () => {
  const dispatch = useDispatch();
  const isMobile = useContext(ScreenSizeContext);

  // Access the navigation state from Redux
  const { logo, menu, loading, error } = useSelector((state) => state.navigation);

  useEffect(() => {
    dispatch(fetchNavigationData()); // Dispatch the async action to fetch navigation data
  }, [dispatch]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <Navbar expand="lg" className="bg-body-tertiary searchbar-navbar" sticky="top">
        <Container fluid className="enterSearchBlockMobile">
          <div className="d-flex justify-content-between align-items-center w-100 gap-0 gap-md-3 gap-xl-4">
            <Navbar.Brand href="/">
              <img src={logo} alt="Logo" />
            </Navbar.Brand>
            <Form className="d-flex w-100 search-block">
              <Form.Control
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <Button variant="outline-success">
                <BsSearch />
              </Button>
            </Form>
            <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
          <Nav className="main-navbar-menu">
                  <NavMenu />
                 
                     {/* <HelplineLanguage /> */}
                
                 
              </Nav>
          </Navbar.Collapse>
          
            <div className="login-signin-cart d-flex align-items-center justify-content-center gap-3 gap-xl-4">
              {!isMobile && (
                <>
                 <CartMenu/>
                  <LogSign />
                </>
              )}
            </div>
          </div>
        </Container>
      </Navbar>
      {isMobile && 
      <Navbar expand="sm" className="bg-body-tertiary main-navbar-menu main-navbar-menu-all" fixed={isMobile ? "bottom" : "none"} >
        <Container fluid="md" className="enterSearchBlockMobile">
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="d-flex align-items-center justify-content-center gap-2 w-100"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
             <NavMenu />
            {/* <HelplineLanguage /> */}
            </Nav>
          </Navbar.Collapse>
          
            <div className="login-signin-cart d-flex align-items-center justify-content-center gap-3 gap-md-5">
             <CartMenu/>
              <LogSign />
            </div>
         
        </Container>
      </Navbar>
}
    </>
  );
};

export default Navigation;
